import React from 'react';
import ReactDOM from 'react-dom';
import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux'
import store from './redux/store';
import { UIProvider } from './app/context/ui';
import { ThemeProvider } from '@material-ui/core/styles'
import { theme } from './assets/theme'
import { environment } from './environments';
import './index.css';
import App from './App';

Sentry.init({
  dsn: 'https://00f13bbbef1191cbdac3d0f7f5265b4a@o4510970954776576.ingest.us.sentry.io/4512300819742720',
  environment: environment.name,
  // Keep local dev noise out of Sentry
  enabled: environment.name !== 'local',
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0,
  // Send trace headers to our API so frontend and mm-api traces link up
  tracePropagationTargets: ['localhost', environment.apiMain],
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <UIProvider>
        <App />
      </UIProvider>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root')
);
